// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"8f6ebc346f747c03af31","655":"28dcca6aaa983044b92c"}[chunkId] + ".js";
};